import { Link } from "react-router-dom";
import { hotArticles } from "@/mocks/anime";

export default function Articles() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="container-x">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-200 bg-primary-100 px-3 py-1 text-sm font-medium text-primary-700">
            <i className="ri-article-line"></i>
            看番指南
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            泡面番怎么刷？小水给你支几招
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
            从选番到排期，从下饭到摸鱼，这里装满了关于短篇速刷的实用心得。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/detail/${article.id}`}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[16/9] w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-950/70 px-2.5 py-1 text-xs font-medium text-background-50">
                  {article.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {article.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    阅读 {article.readMin} 分钟
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}